import type { Form } from '../../interfaces/form.interface';
import type { FormType } from '../../interfaces/form.interface';

export interface ReactiveModalFormStateConfig<TModel> {
    readonly type: FormType;
    readonly model: Partial<TModel>;
    readonly form: Form<TModel>;
    readonly context?: unknown;
}

export interface ReactiveModalFormStateSnapshot<TModel> {
    readonly type: FormType;
    readonly model: Partial<TModel>;
    readonly form: Form<TModel>;
    readonly context: unknown;
}

/** Keeps modal constructor state explicit without coupling the library to app modal components. */
export class ReactiveModalFormState {
    public static create<TModel>(config: ReactiveModalFormStateConfig<TModel>): ReactiveModalFormStateSnapshot<TModel> {
        return {
            type: config.type,
            model: config.model,
            form: config.form,
            context: config.context ?? {},
        };
    }
}
